module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-flex mb-4"
  }, [(!_vm.$route.query.show_hidden) ? _c('router-link', {
    staticClass: "ms-auto showAll",
    attrs: {
      "to": _vm.showHiddenUrl
    }
  }, [_vm._v("Показать скрытые заявки")]) : _c('router-link', {
    staticClass: "ms-auto showAll",
    attrs: {
      "to": _vm.showAllUrl
    }
  }, [_vm._v("Не показывать скрытые заявки")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cc261cae","hasScoped":false,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/views/purchases/components/PurchasesHidePurchaseRequestController.vue
// module id = e31aa2fa5ee8589b7856
// module chunks = 2